import React from 'react';
import { Redirect } from 'react-router-dom';

const ResetPasswordEmail = (props) => {
  localStorage.setItem('email', props.match.params.email);
  return <Redirect to='/account/reset-password' />;
};

export default ResetPasswordEmail;
